import { createFileRoute } from "@tanstack/react-router";
import { ARIZONA_PAGES } from "@/content/localPages";
import { localPageHead } from "@/content/localPageHead";
import { LocalPageView } from "@/components/marketing/LocalPageView";

export const Route = createFileRoute("/google-ads-for-hvac-companies-arizona")({
  head: () => localPageHead(ARIZONA_PAGES.hvac!),
  component: ArizonaPage,
});

function ArizonaPage() {
  return <LocalPageView page={ARIZONA_PAGES.hvac!} />;
}
